import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Heading } from '@grandvisionhq/elements';
import { parseHtml } from '@grandvisionhq/utils';
import Link from '../Link/Link.js';
import { AdditionalInfo } from './AdditionalInfo.js';

const SupportFooter = ({ message , phoneNumber , email , cartConfiguration  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "support-footer"
    }, cartConfiguration && /*#__PURE__*/ React.createElement(AdditionalInfo, swcHelpers.extends({}, cartConfiguration)), /*#__PURE__*/ React.createElement("div", {
        className: "support-footer__container"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "small",
        className: "support-footer__title"
    }, parseHtml(message)), /*#__PURE__*/ React.createElement("div", {
        className: "support-footer__contact-details"
    }, phoneNumber && /*#__PURE__*/ React.createElement(Link, {
        iconBefore: "phone-with-cord",
        url: `tel:${phoneNumber}`,
        className: "support-footer__link"
    }, phoneNumber), email && /*#__PURE__*/ React.createElement(Link, {
        iconBefore: "mail-with-circle",
        url: `mailto:${email}`,
        className: "support-footer__link"
    }, email))));
};
var SupportFooter$1 = SupportFooter;

export { SupportFooter$1 as default };
//# sourceMappingURL=SupportFooter.js.map
